type AuthMode = 'sign-in' | 'sign-up'
const LOCAL_ORIGIN = 'https://axiomgo.invalid'
const CLERK_PARAMS = ['__clerk_ticket', '__clerk_status'] as const

/** Clerk receives a local callback only; its ticket belongs to the auth page. */
export function resolveAuthReturnPath(search: string): string {
  const raw = new URLSearchParams(search).get('redirect_url')
  if (!raw?.startsWith('/') || raw.startsWith('//') || raw.includes('\\')) return '/chat'
  try {
    const url = new URL(raw, LOCAL_ORIGIN)
    if (url.origin !== LOCAL_ORIGIN) return '/chat'
    CLERK_PARAMS.forEach((key) => url.searchParams.delete(key))
    if (url.pathname.startsWith('/invitations/') || /__clerk_(ticket|status)/i.test(url.hash)) {
      url.hash = ''
    }
    return `${url.pathname}${url.search}${url.hash}`
  } catch {
    return '/chat'
  }
}

/** Preserve the official Clerk ticket across auth screens, never in the callback. */
export function buildInvitationAuthUrl(
  mode: AuthMode,
  returnPath: string,
  sourceSearch: string,
  email?: string,
): string {
  const path = resolveAuthReturnPath(new URLSearchParams({ redirect_url: returnPath }).toString())
  if (!/^\/invitations\/[a-z0-9_-]+(?:[?#]|$)/i.test(path)) return `/${mode}`
  const params = new URLSearchParams({ redirect_url: path })
  if (email) params.set('email', email)
  const source = new URLSearchParams(sourceSearch)
  const signInTicket = source.get('__clerk_status') === 'sign_in'
  const target = mode === 'sign-up' && signInTicket ? 'sign-in' : mode
  if (target === 'sign-up' || signInTicket) {
    CLERK_PARAMS.forEach((key) => {
      const value = source.get(key)
      if (value) params.set(key, value)
    })
  }
  return `/${target}?${params}`
}

/** Telemetry may contain a URL directly or nested in a percent-encoded callback. */
export function redactClerkTicket(value: string): string {
  return value.replace(/(__clerk_ticket(?:=|%3d|%253d))[^&#\s"'<>]*/gi, '$1[Redacted]')
}
